import { useState } from 'react';
import { faHand } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type TaskClaimActionPropsType = {
  isTakeOver: boolean;
  onClaim: () => void;
};

export const TaskClaimAction: React.FC<TaskClaimActionPropsType> = ({
  isTakeOver,
  onClaim,
}) => {
  const { t } = useTranslation('tasks');
  const [isArmed, setIsArmed] = useState(false);

  const label = isTakeOver
    ? isArmed
      ? t('ACTIONS.CONFIRM_TAKE_OVER')
      : t('ACTIONS.TAKE_OVER')
    : t('ACTIONS.CLAIM');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();

    if (isTakeOver && !isArmed) {
      setIsArmed(true);
      return;
    }

    onClaim();
  };

  return (
    <Tooltip label={label}>
      <ActionIcon
        size="sm"
        color={isArmed ? 'green' : 'gray'}
        variant={isArmed ? 'filled' : 'subtle'}
        onClick={handleClick}
        aria-label={label}
      >
        <FontAwesomeIcon
          icon={faHand}
          size="sm"
          color="var(--mantine-color-text-4)"
        />
      </ActionIcon>
    </Tooltip>
  );
};
